import { Injectable } from "@angular/core";

//import { HEROES } from "./app";
import { NativeStorage } from '@ionic-native/native-storage/ngx'
import { HttpClient} from "@angular/common/http";
import { Observable } from 'rxjs';
@Injectable({
  // we declare that this service should be created
  // by the root application injector.
  providedIn: "root"
})
export class LoginService {
  //baseurl ="http://localhost:8080/api/";  //LOCAL
  baseurl="https://d3n4kss51hbrv9.cloudfront.net/api/"; //PRODUCCION
  //baseurl="https://d3kn9pwlhosg4a.cloudfront.net/api/"; //PREPRODUCCION
  constructor(private nativeStorage: NativeStorage, private http: HttpClient) {}


  registro(credentials: {
    "name": string,
    "origen": string,
    "phone": number,
    "email": string,
    "pin": number,
    "code":string
    
}): Observable<any>  {
  const headers = { 'Accept': 'application/json',  'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
  return this.http.post<any>(this.baseurl+'webpage/auth/register', credentials, { headers });
 
   
   
  }
  
  payment(credentials: {
    number: number,
    expMonth: number,
    expYear: number,
    cvc: number,
    code: string
   },token): Observable<any>  {
    
  const headers = { 'Authorization': token, 'Accept': 'application/json',  'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
  
  return this.http.post<any>(this.baseurl+'stripe/subscribev2', credentials, { headers });
 
   
   
  }
  
  perfil(credentials: {
    "name": string,
    "origen": string,
    "day": number,
    "month": number,
    "parentName": string,
    "phone": number,
    "parentDay": number,
    "parentyear": number,
    "parentMonth": number,
    "avatar": string,
    "email": string,
    "pin": number,
    
}): Observable<any>  {
    
    

  const headers = { 'Accept': 'application/json',  'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }

   
  return this.http.post<any>(this.baseurl+'auth/register', credentials, { headers });
 
   
   
  }
  payment2(credentials: {
    number: number,
    expMonth: number,
    expYear: number,
    cvc: number
   },token): Observable<any>  {

  const headers = { 'Authorization': token, 'Accept': 'application/json',  'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
  return this.http.post<any>(this.baseurl+'/stripe/subscribev2/', credentials, { headers });
 
   
   
  }
}
